import { useQuery } from '@tanstack/react-query';

import { NANGO_CONNECTIONS_QUERY_KEY } from '../../contracts';
import { nangoClient } from '../../data/api/nango';

export function useQueryNangoConnections(enabled: boolean) {
  return useQuery({
    queryKey: [NANGO_CONNECTIONS_QUERY_KEY],
    queryFn: async () => {
      const { data } = await nangoClient.listConnections();
      return data.connections;
    },
    enabled,
  });
}
